import React from "react";
import img from "../../Assets/Images/banner.jpg";

const SimpleBanner = ({ title, subHeading }) => {
  return (
    <div className="relative w-full h-[150px] sm:h-[200px] md:h-[250px] lg:h-[300px] overflow-hidden">
      <img
        src={img}
        alt="Banner"
        className="absolute inset-0 w-full h-full object-cover"
      />

      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative z-10 font-krona flex items-center justify-end h-full px-4 sm:px-6 md:pr-28 lg:pr-40 ">
        <div className="max-w-[1200px]">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            {title}
          </h1>

          {subHeading && (
            <p className="mt-3 text-sm sm:text-base md:text-lg text-white/90">
              {subHeading}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimpleBanner;
